import { useQuery } from '@tanstack/vue-query'
import { queries } from '@/keys'
import type { User } from '~/types/auth'

const useCurrentUser = (enabled?: boolean) => {
  const authStore = useAuthStore()

  return useQuery({
    ...queries.users.me,
    queryFn: () => {
      if (!authStore.token) return null
      return $fetch<User>(`/api/user/${authStore.user?.id}`, {
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      })
    },
    enabled,
    retry: false,
    select: (data) => {
      authStore.updateUser(JSON.parse(data))
      return JSON.parse(data)
    },
  })
}

export default useCurrentUser
